module.exports = __webpack_public_path__ + "static/media/UpgradeBccCRM.db0cacba.png";